import { render } from "./FinancialAccountHistory.vue?vue&type=template&id=065f081d"
import script from "./FinancialAccountHistory.vue?vue&type=script&lang=js"
export * from "./FinancialAccountHistory.vue?vue&type=script&lang=js"

import "./styles.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__